import { z } from 'zod';

import { responsiveSchema } from '../../../../utils';
import { widgetBaseSchema } from '../../../common/schemas/base';
import { buttonHorizontalPositionSchema } from '../../../common/schemas/legacy/button-settings';
import { LINE_SIZE_BOUNDS } from '../legacy/styles';

/**
 * Line (divider) settings, v0. The field names are the legacy ones on purpose:
 * v0 only moves them into `props` and pushes the breakpoint down to each leaf
 * (`{ desktop, mobile? }`, as grid does); a redesign lands as v1.
 *
 * `horizontalAlign` comes from legacy `data`, the rest from `styles`, and the
 * `mobile` leaves from the persisted `mobileStyles` bag.
 */
export const lineDefaultDataSchema = z.object({
    horizontalAlign: responsiveSchema(buttonHorizontalPositionSchema),
    borderTopColor: responsiveSchema(z.string()),
    borderTopWidth: responsiveSchema(z.number().meta(LINE_SIZE_BOUNDS)),
    borderTopStyle: responsiveSchema(z.enum(['solid', 'dashed', 'dotted'])),
    /** A PERCENTAGE of the column (0–100), not pixels. */
    width: responsiveSchema(z.number().meta(LINE_SIZE_BOUNDS)),
    /** Wrapper margin shorthand — never edited in the UI; `null` where legacy had none. */
    margin: responsiveSchema(z.string().nullable()),
});

export const lineDefaultSchema = widgetBaseSchema.extend({
    entityType: z.literal('widget:line'),
    entitySubType: z.literal('default'),
    props: lineDefaultDataSchema,
    version: z.literal(0),
});

export const lineDefaultV0Schema = lineDefaultSchema;
export type LineDefaultV0 = z.infer<typeof lineDefaultV0Schema>;
